var _rect, _rect2, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 19.0367C12.5 16.1397 15.8647 13.7825 20 13.7825C24.1363 13.7825 27.5 16.1397 27.5 19.0367C27.5 21.9327 24.1353 24.2889 20 24.2889C19.7521 24.2889 19.5103 24.2789 19.2695 24.2608C18.0462 25.5573 16.5651 26.2156 14.8662 26.2156C14.6886 26.2156 14.527 26.1072 14.4588 25.9426C14.3896 25.777 14.4277 25.5884 14.5541 25.461C14.8883 25.1258 15.4833 24.32 15.9028 23.4379C13.7915 22.4766 12.5 20.8189 12.5 19.0367ZM19.1129 23.4229C19.4039 23.449 19.6979 23.466 19.999 23.466C23.7078 23.466 26.7243 21.4731 26.7243 19.0237C26.7262 16.5712 23.7088 14.5773 20 14.5773C16.2911 14.5773 13.2737 16.5712 13.2737 19.0216C13.2737 20.574 14.5451 22.0381 16.5932 22.8429C16.7036 22.8881 16.7939 22.9753 16.8411 23.0837C16.8862 23.1931 16.8892 23.3185 16.844 23.4279C16.5791 24.0932 16.1838 24.7766 15.7984 25.3255C16.9093 25.1067 17.8947 24.5217 18.7396 23.5714C18.8329 23.466 18.9714 23.4129 19.1129 23.4229ZM23.5565 19.9852H16.426C16.2839 20.0016 16.204 20.0726 16.1882 20.2002V20.4141C16.204 20.5427 16.2839 20.6136 16.426 20.628H23.5565C23.6996 20.6136 23.7805 20.5427 23.7953 20.4141V20.2002C23.7805 20.0726 23.6996 20.0016 23.5565 19.9852ZM16.4441 17.7038H23.5746C23.7177 17.7192 23.7986 17.7903 23.8134 17.9181V18.1324C23.7986 18.2612 23.7177 18.3322 23.5746 18.3466H16.4441C16.302 18.3322 16.2221 18.2612 16.2063 18.1324V17.9181C16.2221 17.7903 16.302 17.7192 16.4441 17.7038Z",
    fill: "#4C4C4C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_164_339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 19.0367C12.5 16.1397 15.8647 13.7825 20 13.7825C24.1363 13.7825 27.5 16.1397 27.5 19.0367C27.5 21.9327 24.1353 24.2889 20 24.2889C19.7521 24.2889 19.5103 24.2789 19.2695 24.2608C18.0462 25.5573 16.5651 26.2156 14.8662 26.2156C14.6886 26.2156 14.527 26.1072 14.4588 25.9426C14.3896 25.777 14.4277 25.5884 14.5541 25.461C14.8883 25.1258 15.4833 24.32 15.9028 23.4379C13.7915 22.4766 12.5 20.8189 12.5 19.0367ZM19.1129 23.4229C19.4039 23.449 19.6979 23.466 19.999 23.466C23.7078 23.466 26.7243 21.4731 26.7243 19.0237C26.7262 16.5712 23.7088 14.5773 20 14.5773C16.2911 14.5773 13.2737 16.5712 13.2737 19.0216C13.2737 20.574 14.5451 22.0381 16.5932 22.8429C16.7036 22.8881 16.7939 22.9753 16.8411 23.0837C16.8862 23.1931 16.8892 23.3185 16.844 23.4279C16.5791 24.0932 16.1838 24.7766 15.7984 25.3255C16.9093 25.1067 17.8947 24.5217 18.7396 23.5714C18.8329 23.466 18.9714 23.4129 19.1129 23.4229ZM23.5565 19.9852H16.426C16.2839 20.0016 16.204 20.0726 16.1882 20.2002V20.4141C16.204 20.5427 16.2839 20.6136 16.426 20.628H23.5565C23.6996 20.6136 23.7805 20.5427 23.7953 20.4141V20.2002C23.7805 20.0726 23.6996 20.0016 23.5565 19.9852ZM16.4441 17.7038H23.5746C23.7177 17.7192 23.7986 17.7903 23.8134 17.9181V18.1324C23.7986 18.2612 23.7177 18.3322 23.5746 18.3466H16.4441C16.302 18.3322 16.2221 18.2612 16.2063 18.1324V17.9181C16.2221 17.7903 16.302 17.7192 16.4441 17.7038Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_164_339)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a01609697c38496fb1959f55e1dfffe9.svg";
export { ForwardRef as ReactComponent };